function init() {
    // let elements = [...document.querySelectorAll('.director-post')];

    // if (elements.length) {
    //     let currentIndex = elements.length - 1;

    //     while (currentIndex) {
    //         const randomIndex = Math.floor(Math.random() * currentIndex);

    //         const currentElement = elements[currentIndex];
    //         const randomElement = elements[randomIndex];
    //         const currentParent = currentElement.parentElement;
    //         const randomParent = randomElement.parentElement;

    //         currentParent.removeChild(currentElement);
    //         randomParent.removeChild(randomElement);
    //         currentParent.appendChild(randomElement);
    //         randomParent.appendChild(currentElement);

    //         elements = [...document.querySelectorAll('.director-post')];
    //         currentIndex--;
    //     }
    // }

    var filter_category = '';

    var url = window.location.search;
    var regex = new RegExp('[?&]' + 'filter' + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (results) {
        filter_category = decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    var per_page = 4;
    filter(per_page, filter_category);
    if($('.director-post').length > 0) {
        $(window).on('scroll', function (e) {
            if ((window.pageYOffset && window.innerHeight + window.pageYOffset - 30 >= $('.load-more a').offset().top)
                || (window.innerHeight + window.scrollY - 30 >= $('.load-more a').offset().top)) {

                var p = 0;
                $.each($('.director-post.filtered.dnone'), function (p, post) {
                    p++;
                    if (p <= per_page) {
                        $('.director-post.filtered.dnone').removeClass('dnone');
                    }
                });
                if ($('.director-post.filtered.dnone').length == 0) {
                    $('.load-more a').hide();
                }
            }
        });
    }

    var relatedCardsDirector = $('.related-grid-items-director');
    if (relatedCardsDirector.length > 0) {
        (relatedCardsDirector).find('.col-6').eq(0).addClass('darkened');
    }

    (relatedCardsDirector).find('.darkened').on('click', function(e) {
        e.preventDefault();
        location.reload();
    })
}

function filter(per_page, filter_category) {
    var p = 0;
    var directors = $('.director-post');
    if (filter_category != '') {
        $.each(directors, function (d, director) {
            $(director).addClass('dnone');
            $(director).removeClass('filtered');
            var categories = $(director).data('filter-categories').split(',');
            if (categories.length > 0)
                $.each(categories, function (c, category) {
                    if (filter_category == category) {
                        p++;
                        $(director).addClass('filtered');
                        if (p <= per_page) {
                            $(director).removeClass('dnone');
                        }
                    }
                });
        });
    } else {
        $(directors).addClass('filtered');
        $.each(directors, function (d, director) {
            p++;
            $(director).addClass('filtered');
            if (p <= per_page) {
                $(director).removeClass('dnone');
            }
        });
    }

    if ($('.director-post.filtered.dnone').length == 0) {
        $('.load-more a').hide();
    }
}

module.exports = {
    init: init
};